import React from 'react';
import './toast.css';
export var ToastType;
(function (ToastType) {
    ToastType["error"] = "error";
    ToastType["warning"] = "warning";
    ToastType["info"] = "info";
})(ToastType || (ToastType = {}));
export default class Toaster extends React.Component {
    constructor() {
        super(...arguments);
        this.toastCounter = 0;
        this.state = {
            toasts: [],
        };
    }
    addToast(toast) {
        const nState = this.state;
        const extToast = Object.assign({ shown: false, uid: this.toastCounter++ }, toast);
        if (extToast.autohide === undefined && extToast.type === ToastType.info && !extToast.modal)
            extToast.autohide = 3;
        nState.toasts.push(extToast);
        this.setState(nState);
        if (extToast.autohide !== undefined) {
            setTimeout(this.onHide.bind(this, extToast.uid), extToast.autohide * 1000);
        }
    }
    onHide(uidToast) {
        const nState = this.state;
        const found = nState.toasts.findIndex((toast) => toast.uid === uidToast);
        if (found !== -1) {
            if (nState.toasts[found].saveInHistory) {
                nState.toasts[found].shown = true;
            }
            else
                nState.toasts.splice(found, 1);
        }
        this.setState(nState);
    }
    render() {
        const countModal = this.state.toasts.filter((t) => !t.shown && t.modal).length;
        const countToShow = this.state.toasts.filter((t) => !t.shown).length;
        return (React.createElement("div", { className: `plutchik-toasts-container${countModal > 0 ? '-modal' : ''}`, style: countToShow === 0 ? { display: 'none' } : {} },
            countModal > 0 ? React.createElement("div", { className: 'plutchik-toasts-fade' }) : React.createElement(React.Fragment, null),
            React.createElement("div", { className: 'plutchik-toast-container-center' },
                this.props.placesCount < countToShow ? (React.createElement("span", { className: 'plutchik-toast-container-count-label' },
                    "Hide all ",
                    countToShow > 9 ? '9+' : countToShow)) : (React.createElement(React.Fragment, null)),
                this.state.toasts
                    .filter((toast) => !toast.shown)
                    .filter((t, i) => i < this.props.placesCount && t)
                    .map((toast) => (React.createElement(Toast, Object.assign({ key: toast.uid }, toast, { onHide: this.onHide.bind(this) })))))));
    }
}
export class Toast extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            showDescription: false,
        };
    }
    toggleDescription() {
        const nState = this.state;
        nState.showDescription = !nState.showDescription;
        nState.showDescription = this.props.description !== undefined ? nState.showDescription : false;
        this.setState(nState);
    }
    render() {
        return (React.createElement("div", { className: `plutchik-toast-container-${this.props.type}` },
            React.createElement("span", { onClick: () => {
                    if (this.props.onHide)
                        this.props.onHide(this.props.uid);
                }, className: 'plutchik-toast-close-button' },
                React.createElement("span", null, "+")),
            this.props.description !== undefined ? (React.createElement("span", { onClick: this.toggleDescription.bind(this), className: `plutchik-toast-description-button${this.state.showDescription ? '-selected' : ''}` },
                React.createElement("span", null, "\u2234"))) : (React.createElement(React.Fragment, null)),
            React.createElement("div", { className: 'plutchik-toast-message' }, this.props.message),
            this.state.showDescription ? (React.createElement("div", { className: 'plutchik-toast-description' }, this.props.description)) : (React.createElement(React.Fragment, null))));
    }
}
